"use strict";

var _interopRequireDefault = require("D:/www/ssz_gold_backend/multi_merchant_web/gold_admin/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name");

var _objectSpread2 = _interopRequireDefault(require("D:/www/ssz_gold_backend/multi_merchant_web/gold_admin/node_modules/@babel/runtime/helpers/objectSpread2"));

var _recommend = require("@/api/recommend");

var _customPage = _interopRequireDefault(require("@/components/customPage"));

var _goods = _interopRequireDefault(require("./goods"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    customPage: _customPage.default,
    goodsDialog: _goods.default
  },
  data: function data() {
    return {
      searchForm: {
        title: '',
        shopname: '',
        category_id: '',
        status: ''
      },
      activeName: '',
      total: 0,
      tableData: [],
      tabList: [],
      categoryList: []
    };
  },
  methods: {
    // 上架/下架推广
    changeStatus: function changeStatus(id, status) {
      var _this = this;

      var tip = "",
          title = "";

      if (status == 1) {
        tip = "您确定要下架推广吗？";
        title = "下架推广";
      } else {
        tip = "您确定要上架推广吗？";
        title = "上架推广";
      }

      this.$confirm(tip, title, {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _recommend.addOrEditH5PromotionGoods)({
          id: id,
          promotion_cate_id: _this.activeName,
          status: status == 2 ? 1 : 2
        }).then(function (res) {
          _this.getList(true);
        });
      }).catch(function () {});
    },
    // 更改排序
    changeSort: function changeSort(id, val) {
      var _this2 = this;

      (0, _recommend.addOrEditH5PromotionGoods)({
        id: id,
        promotion_cate_id: this.activeName,
        sort: val
      }).then(function (res) {
        _this2.getList(true);
      });
    },
    getList: function getList(flag) {
      var _this3 = this;

      // flag为true, 则不刷新表格
      var _this$$refs$customPag = this.$refs.customPage,
          page = _this$$refs$customPag.page,
          pageSize = _this$$refs$customPag.pageSize;

      if (!flag) {
        this.tableData = [];
      }

      (0, _recommend.h5PromotionGoodsList)((0, _objectSpread2.default)({
        page: page,
        pageSize: pageSize,
        promotion_cate_id: this.activeName
      }, this.searchForm)).then(function (res) {
        _this3.tableData = res.data || [];
        _this3.total = res.total;
      });
    },
    getClassify: function getClassify() {
      var _this4 = this;

      (0, _recommend.h5PromotionCate)().then(function (res) {
        _this4.tabList = res || [];
        _this4.activeName = _this4.tabList[0] ? _this4.tabList[0].id + '' : '';

        _this4.getList();
      });
    },
    // 查询
    search: function search() {
      this.$refs.customPage.page = 1;
      this.getList();
    },
    // 重置
    reset: function reset() {
      this.searchForm = {
        title: '',
        shopname: '',
        category_id: '',
        status: ''
      };
      this.$refs.customPage.page = 1;
      this.getList();
    },
    handleClick: function handleClick(tab) {
      this.activeName = tab.name;
      this.$refs.customPage.page = 1;
      this.reset();
    },
    getSelectList: function getSelectList() {
      var _this5 = this;

      (0, _recommend.getSecondCategory)().then(function (res) {
        _this5.categoryList = res || [];
      });
    },
    openAdd: function openAdd() {
      this.$refs.goodsDialog.dialogVisible = true;
    }
  },
  mounted: function mounted() {
    this.getClassify();
    this.getSelectList();
  }
};
exports.default = _default;